import * as React from 'react'

import ConfirmDialog from '~/client/src/shared/components/ConfirmDialog/ConfirmDialog'
import type { DialogPortalContainer } from '~/client/src/shared/components/shadcn-ui/dialog'
import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  isShown: boolean
  onHide: () => void
  onApply: () => void
  // Whether applying leaves the request unsubmittable — not which setting made
  // it so. The copy promises the user an outcome, so it has to follow the
  // outcome, never a gate that may or may not be the one in force.
  shouldBlockSubmit: boolean
  entityName: string

  title?: string
  message?: string
  portalContainer?: DialogPortalContainer
}

const changeDateTimeToWorkday = 'Change date-time to a workday'
const entityForNonWorkDayTime = (entityName: string) =>
  `${entityName} for non-work day-time`
const pleaseMoveThisRequest = 'Please move this Request to a work day-time'
const thisRequestIsForNonWorkdayOrTime =
  'This Request is for a non-workday or time'

export default class NonWorkTimeConfirmDialog extends React.Component<IProps> {
  public render() {
    const { isShown, onHide, onApply, portalContainer } = this.props

    return (
      <ConfirmDialog
        isOpen={isShown}
        title={this.dialogTitle}
        onCancelClicked={onHide}
        onDoneClicked={onApply}
        doneTitle={this.dialogApplyButtonText}
        portalContainer={portalContainer}
      >
        <div className="tw:text-body-md tw:text-foreground">
          {this.dialogMessage}
        </div>
      </ConfirmDialog>
    )
  }

  private get dialogTitle(): string {
    const { shouldBlockSubmit, entityName, title } = this.props

    if (title) {
      return title
    }

    return shouldBlockSubmit
      ? changeDateTimeToWorkday
      : entityForNonWorkDayTime(entityName)
  }

  private get dialogMessage(): string {
    const { shouldBlockSubmit, message } = this.props

    if (message) {
      return message
    }

    return shouldBlockSubmit
      ? pleaseMoveThisRequest
      : thisRequestIsForNonWorkdayOrTime
  }

  private get dialogApplyButtonText(): string {
    return this.props.shouldBlockSubmit
      ? Localization.translator.ok
      : Localization.translator.requestAnyway
  }
}
